import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Mapper } from '@digibricks/core';
import { QuestionType } from '../../../../core';
export var QuestionApiMapper = /*#__PURE__*/function (_Mapper) {
  _inherits(QuestionApiMapper, _Mapper);

  var _super = _createSuper(QuestionApiMapper);

  function QuestionApiMapper() {
    _classCallCheck(this, QuestionApiMapper);

    return _super.apply(this, arguments);
  }

  _createClass(QuestionApiMapper, [{
    key: "toDomain",
    value: function toDomain(persistenceModel) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "fromDomain",
    value: function fromDomain(domainModel) {
      var type = domainModel.type;
      var files = domainModel.files.map(function (f) {
        return {
          id: f.id.toString(),
          url: f.url,
          type: f.type,
          size: f.size
        };
      });
      var questionDtoModel = {
        id: domainModel.id.toString(),
        description: domainModel.description ? domainModel.description.trim() : '',
        // Trim description before API
        type: domainModel.type,
        sectionId: domainModel.sectionId,
        formId: domainModel.formId,
        score: domainModel.score,
        explanation: domainModel.explanation ? domainModel.explanation.trim() : '',
        // Trim explanation before API
        previousQuestionId: domainModel.previousQuestionId,
        subQuestions: domainModel.subQuestions,
        files: files,
        audioFile: domainModel.audioFile ? {
          rule: {
            numberOfReplays: domainModel.audioFile.rule.numberOfReplays.value,
            isAutoPlay: domainModel.audioFile.rule.isAutoPlay,
            allowingToPauseAndStop: domainModel.audioFile.rule.allowingToPauseAndStop,
            isAllowedToReplay: domainModel.audioFile.rule.isAllowedToReplay
          },
          url: domainModel.audioFile.url,
          type: domainModel.audioFile.type,
          size: domainModel.audioFile.size
        } : null
      };

      if (domainModel.headingId) {
        questionDtoModel.headingId = domainModel.headingId;
      }

      if (domainModel.nextHeadingId) {
        questionDtoModel.nextHeadingId = domainModel.nextHeadingId;
      }

      switch (type) {
        case QuestionType.MultipleChoice:
        case QuestionType.SingleChoice:
          {
            var singleChoiceOrMultipleChoiceQuestion = domainModel;
            var answers = singleChoiceOrMultipleChoiceQuestion.answers.map(function (a) {
              return {
                id: a.id.toString(),
                description: a.description ? a.description.trim() : '',
                // Trim description before API
                files: a.files.map(function (f) {
                  return {
                    id: f.id.toString(),
                    url: f.url,
                    type: f.type,
                    size: f.size
                  };
                })
              };
            });
            var correctAnswers = singleChoiceOrMultipleChoiceQuestion.correctAnswers.map(function (c) {
              return {
                id: c.id.toString(),
                answerId: c.answerId
              };
            });
            questionDtoModel.answers = answers;
            questionDtoModel.correctAnswers = correctAnswers;
          }
          break;

        case QuestionType.FillInBlank:
          {
            var fillInBlankQuestion = domainModel;

            var _answers = fillInBlankQuestion.answers.map(function (a) {
              // For fill-in-blank, description contains comma-separated values
              // Need to trim each individual value: " aasd", "ab", "asd " -> "aasd,ab,asd"
              var trimmedDescription = '';

              if (a.description) {
                var splitValues = a.description.split(',');
                var trimmedValues = splitValues.map(function (val) {
                  return val.trim();
                }).filter(function (val) {
                  return val.length > 0;
                });
                trimmedDescription = trimmedValues.join(',');
              }

              return {
                id: a.id.toString(),
                description: trimmedDescription,
                files: a.files.map(function (f) {
                  return {
                    id: f.id.toString(),
                    url: f.url,
                    type: f.type,
                    size: f.size
                  };
                })
              };
            });

            var _correctAnswers = fillInBlankQuestion.correctAnswers.map(function (c) {
              var correctAnswer = c;
              return {
                id: c.id.toString(),
                answerId: c.answerId,
                score: correctAnswer.score
              };
            });

            questionDtoModel.answers = _answers;
            questionDtoModel.correctAnswers = _correctAnswers;
            questionDtoModel.score = null;
          }
          break;

        case QuestionType.Matching:
          {
            var matchingQuestion = domainModel;

            var _answers2 = matchingQuestion.answers.map(function (a) {
              return {
                id: a.id.toString(),
                description: a.description ? a.description.trim() : '',
                // Trim description before API
                files: a.files.map(function (f) {
                  return {
                    id: f.id.toString(),
                    url: f.url,
                    type: f.type,
                    size: f.size
                  };
                })
              };
            });

            var _correctAnswers2 = matchingQuestion.correctAnswers.map(function (c) {
              var correctAnswer = c;
              return {
                id: c.id.toString(),
                answerId: c.answerId,
                subQuestionId: correctAnswer.subQuestionId,
                score: correctAnswer.score
              };
            });

            var subQuestions = matchingQuestion.subQuestions.map(function (subQ) {
              return {
                id: subQ.id.toString(),
                index: subQ.index,
                description: subQ.description ? subQ.description.trim() : '' // Trim description before API

              };
            });
            questionDtoModel.answers = _answers2;
            questionDtoModel.correctAnswers = _correctAnswers2;
            questionDtoModel.subQuestions = subQuestions;
            questionDtoModel.score = null;
          }
          break;
      }

      return questionDtoModel;
    }
  }]);

  return QuestionApiMapper;
}(Mapper);